import { useState } from 'react'
import { isMobile } from '@repo/utils'
import useResizeListener from './useResizeListener'

export default function useDeviceDetect() {
  const [isMobileState, setMobile] = useState(isMobile())

  const updateDeviceType = () => {
    const mobile = isMobile()
    setMobile(mobile)
  }

  useResizeListener(updateDeviceType)

  return { isMobile: isMobileState }
}
